import { PARAM_KEY } from "constants/navigation";

export function addNewURLQueryParams(
  newParamValue: string,
  paramKey: PARAM_KEY,
  paramsValue: URLSearchParams
): URLSearchParams {
  const next = new URLSearchParams(paramsValue);
  next.set(paramKey, newParamValue);
  return next;
}
